import { useContext } from "react";
import ScdSummaryStepsBlue from "../../../../resources/images/scd-summary-steps-blue.svg";
import ScdSummaryStepsRed from "../../../../resources/images/scd-summary-steps-red.svg";
import CustomImage from "../../../../ui/widgets/image";
import { ProductContext } from "../../../../context/product-context/productContext";
import { resolveThemeProductFamily } from "../../../../theme/theme";

import "./styles.scss";

const SummaryStepImage = () => {
  const { selectedProduct } = useContext(ProductContext);

  const SummaryStepImage =
    resolveThemeProductFamily(selectedProduct) === "CS_DUO"
      ? ScdSummaryStepsBlue
      : ScdSummaryStepsRed;

  return (
    <CustomImage
      className="summary-step-image-override"
      src={SummaryStepImage}
    />
  );
};

export default SummaryStepImage;
